const routes = [
  {
    path: '/in-production',
    component: () => import('./1index.vue'),
  },
];

export default routes;
